<template>
  <div>
    <div class="row">
      <div class="mx-auto col-md-12">
        <div class="card p-3 mb-3">
          <div class="card-body">
            <!-- primeiro caso, NAO consegui recuperar os dados -->
            <div v-if="erroRecuperaDadosCidadao">
              <!-- se for uma resposta esperada da API -->
              <div v-if="erroAPI">
                <msg-dados-invalidos
                  :bRetornoComDados="true"
                ></msg-dados-invalidos>
                <div v-if="temBeneficioExtra" class="alert alert-warning">
                  <p>
                    Seus dados não foram encontrados no cadastro de famílias
                    vulneráveis, mas foram localizados no cadastro de famílias
                    de estudantes matriculados na Rede Municipal de Ensino.
                    <br />Acesse
                    <a
                      href="https://cestaestudante.pbh.gov.br"
                      target="_blank"
                      rel="noopener noreferrer"
                      >cestaestudante.pbh.gov.br</a
                    >, informe seus dados e realize a consulta para a retirada
                    do benefício.
                    <br />
                  </p>
                </div>
              </div>
              <div v-else>
                <!-- caso de logins insconsistentes em funcao de problemas no banco -->
                <msg-login-inconsistente
                  v-if="erroLoginInconsistente"
                ></msg-login-inconsistente>
                <!-- se for uma resposta inesperada (rede, banco etc) -->
                <div v-else class="alert alert-danger">
                  {{ erroRecuperaDadosCidadao }}
                </div>
              </div>
            </div>

            <!-- caso contrario, consegui recuperar os dados -->
            <div v-else>
              <!-- se o usuario considera que os dados NAO conferem -->
              <msg-dados-invalidos
                v-if="resposta == 'nao'"
              ></msg-dados-invalidos>

              <!-- se os dados foram recuperados e o usuario 1. ainda nao respondeu a pergunta, ou 2. respondeu positivamente -->
              <div v-if="dadosCidadao && resposta != 'nao'">
                <p>
                  <strong>CPF:</strong>
                  {{ dadosCidadao.cpf_resp | formataCpf }}
                </p>
                <p>
                  <strong>Nome:</strong>
                  {{ dadosCidadao.nome_responsavel }}
                </p>

                <!-- se o usuario ainda nao respondeu a pergunta -->
                <div v-if="resposta == null">
                  As informações conferem?
                  <div class="row">
                    <div class="col">
                      <button
                        class="btn btn-success btn-block"
                        @click="responder('sim')"
                      >
                        Sim!
                      </button>
                    </div>
                    <div class="col">
                      <button
                        class="btn btn-danger btn-block"
                        @click="responder('nao')"
                      >
                        Não.
                      </button>
                    </div>
                  </div>
                </div>

                <!-- se o usuario respondeu positivamente -->
                <div v-else>
                  <!-- erro inesperado ao recuperar dados do supermercado (rede, banco etc) -->
                  <div
                    v-if="erroRecuperaDadosSupermercado"
                    class="alert alert-danger"
                  >
                    {{ erroRecuperaDadosSupermercado }}
                  </div>

                  <div
                    v-if="resposta == 'sim' && dadosSupermercado"
                    class="alert alert-success"
                  >
                    Você tem direito a
                    <strong>{{ dadosSupermercado.tipo_produto }}</strong
                    >. <br />No dia
                    <strong>{{ dadosSupermercado.data_retirada }}</strong
                    >, no período da
                    <strong id="turno">{{ dadosSupermercado.turno }}</strong
                    >, dirija-se ao supermercado
                    <strong>{{ dadosSupermercado.nome_exibicao }}</strong>
                    (
                    <strong>{{ dadosSupermercado.endereco_exibicao }}</strong>
                    ) para retirada do seu benefício do mês de
                    {{ mesReferencia }}/{{ anoReferencia }} de posse do seu CPF
                    e do voucher:
                    <div class="my-4 card mx-auto" style="width: 70%">
                      <div class="card-body">
                        <h1 class="text-center">
                          {{ dadosSupermercado.voucher }}
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--

                ----------------------------------------
                -
                -
                -
                -


            -->

            <b-card class="mb-2" header="Beneficiário" header-tag="header">
              <b-card-text>CPF: {{ cpf }}</b-card-text>
              <b-card-text>Nome: {{ nome }}</b-card-text>
              <!-- <b-button v-if="habilitaAlteraRF" @click="alterarResp" variant="outline-primary">Solicitar alteração responsável</b-button>-->
            </b-card>

            <b-card
              class="mb-2"
              header="Verifique e acerte seus dados"
              header-tag="header"
            >
              <b-form inline>
                <div class="p-0 mb-3 col-12 d-md-flex">
                  <label class="mr-sm-1 col-md-2 p-0" for="data_nascimento"
                    >Data Nascimento</label
                  >
                  <b-form-input
                    id="data_nascimento"
                    v-model="$v.form.data_nascimento.$model"
                    type="date"
                    required
                    :class="$v.form.data_nascimento.$error ? ` is-invalid` : ``"
                    :disabled="form.alteracao_receita === 'S'"
                  ></b-form-input>
                  <div
                    class="error mt-2 d-block ml-2"
                    v-if="!$v.form.data_nascimento.idadeMinima"
                  >
                    <small
                      >Idade mínima para o beneficiário é de 16 anos.</small
                    >
                  </div>
                </div>

                <div class="p-0 mb-3 col-12 d-md-flex">
                  <label class="mr-sm-1 col-md-2 p-0" for="nome_mae"
                    >Nome da mãe</label
                  >
                  <b-form-input
                    id="nome_mae"
                    v-model="$v.form.nome_mae.$model"
                    type="text"
                    placeholder="Nome"
                    required
                    :class="
                      `w-100` + ($v.form.nome_mae.$error ? ` is-invalid` : ``)
                    "
                    @keyup.native="removeAcentos($event)"
                    :disabled="form.alteracao_receita === 'S'"
                  ></b-form-input>
                </div>

                <div class="p-0 mb-3 col-12 d-md-flex">
                  <label class="mr-sm-1 col-md-2 p-0" for="sexo">Sexo</label>
                  <b-form-radio-group
                    id="sexo"
                    v-model="$v.form.sexo.$model"
                    :options="tipoSexo"
                    required
                    :class="
                      `w-100` + ($v.form.sexo.$error ? ` is-invalid` : ``)
                    "
                  >
                  </b-form-radio-group>
                </div>

                <div class="p-0 mb-3 col-12 d-md-flex">
                  <label class="mr-sm-1 col-md-2 p-0" for="tipo_documento"
                    >Tipo Documento</label
                  >
                  <b-form-select
                    id="tipo_documento"
                    v-model="$v.form.tipo_documento.$model"
                    :options="tipos"
                    :class="
                      `mb-2 mr-sm-1 mb-sm-0 col-md-3` +
                      ($v.form.tipo_documento.$error ? ` is-invalid` : ``)
                    "
                    @change.native="changeTipoDocumento"
                  ></b-form-select>

                  <label class="mr-sm-1 col-md-3 p-0" for="numero_documento"
                    >Número documento</label
                  >
                  <the-mask
                    id="numero_documento"
                    pattern="[0-9\.\-]*"
                    inputmode="numeric"
                    mask="####################"
                    placeholder="Somente números"
                    :masked="false"
                    v-model="$v.form.numero_documento.$model"
                    type="text"
                    required
                    :class="
                      `w-100 form-control` +
                      ($v.form.numero_documento.$error ? ` is-invalid` : ``)
                    "
                  ></the-mask>
                </div>

                <div class="p-0 mb-3 col-12 d-md-flex">
                  <label class="mr-sm-1 col-md-2 p-0" for="orgao_emissor"
                    >Órgão emissor</label
                  >
                  <b-form-input
                    id="orgao_emissor"
                    v-model="$v.form.orgao_emissor.$model"
                    type="text"
                    required
                    placeholder="Somente letras"
                    :class="
                      `col-md-2 mb-2` +
                      ($v.form.orgao_emissor.$error ? ` is-invalid` : ``)
                    "
                    @keypress.native="isLetter($event)"
                    @keyup.native="removeAcentos($event)"
                    @change.native="changeOrgao()"
                  ></b-form-input>

                  <label class="mr-sm-1 col-md-1 p-0" for="uf_orgao_emissor"
                    >UF</label
                  >
                  <b-form-select
                    id="uf_orgao_emissor"
                    v-model="$v.form.uf_orgao_emissor.$model"
                    :class="
                      `mb-2 mr-sm-1 mb-sm-0` +
                      ($v.form.uf_orgao_emissor.$error ? ` is-invalid` : ``)
                    "
                    :options="estados"
                  ></b-form-select>

                  <label class="mr-sm-1 col-md-2 p-0" for="data_emissao"
                    >Data emissão</label
                  >
                  <b-form-input
                    id="data_emissao"
                    v-model="$v.form.data_emissao.$model"
                    type="date"
                    required
                    :class="
                      `w-100` +
                      ($v.form.data_emissao.$error ? ` is-invalid` : ``)
                    "
                  ></b-form-input
                  ><br />
                </div>

                <div
                  class="error text-right w-100 mt-0"
                  v-if="$v.form.data_emissao.$error"
                >
                  <div v-if="!$v.form.data_emissao.menorQueHoje">
                    <small
                      >Data de emissão não pode ser maior que a data de
                      hoje.</small
                    >
                  </div>
                </div>

                <div
                  class="p-0 mb-3 col-12 d-md-flex"
                  v-if="form.tipo_documento == 3 || form.tipo_documento == 4"
                >
                  <label
                    class="mr-sm-1 col-md-2 p-0"
                    for="data_validade"
                    v-if="form.tipo_documento == 3"
                    >Validade documento</label
                  >
                  <b-form-input
                    id="data_validade"
                    v-model="form.data_validade"
                    type="date"
                    required
                    :class="
                      `col-md-2 mb-2 w-100` +
                      ($v.form.data_validade.$error ? ` is-invalid` : ``)
                    "
                    :disabled="form.tipo_documento != 3"
                    v-if="form.tipo_documento == 3"
                  ></b-form-input>

                  <label
                    class="mr-sm-1 col-md-2 p-0"
                    for="pais_emissao"
                    v-if="form.tipo_documento == 3"
                    >País Emissão</label
                  >
                  <b-form-select
                    id="pais_emissao"
                    v-model="form.pais_emissao"
                    :options="paises"
                    :class="
                      `mb-2 mr-sm-1 mb-sm-0 col-md-2` +
                      ($v.form.pais_emissao.$error ? ` is-invalid` : ``)
                    "
                    :disabled="form.tipo_documento != 3"
                    v-if="form.tipo_documento == 3"
                  ></b-form-select>

                  <label
                    class="mr-sm-1 col-md-2 p-0"
                    for="serie_documento"
                    v-if="form.tipo_documento == 4"
                    >Série documento</label
                  >
                  <b-form-input
                    id="serie_documento"
                    v-model="form.serie_documento"
                    type="text"
                    :class="
                      `w-100` +
                      ($v.form.serie_documento.$error ? ` is-invalid` : ``)
                    "
                    :disabled="form.tipo_documento != 4"
                    v-if="form.tipo_documento == 4"
                  ></b-form-input>
                </div>

                <div class="p-0 mb-3 col-12 d-md-flex">
                  <label class="mr-sm-1 col-md-2 p-0" for="cep_endereco"
                    >Cep</label
                  >
                  <the-mask
                    id="cep_endereco"
                    pattern="[0-9\.\-]*"
                    inputmode="numeric"
                    mask="#####-###"
                    :masked="false"
                    v-model="$v.form.cep_endereco.$model"
                    type="text"
                    required
                    :class="
                      `col-md-2 mb-2 form-control` +
                      ($v.form.cep_endereco.$error ? ` is-invalid` : ``)
                    "
                    @input="buscaCep"
                  ></the-mask>

                  <label class="mr-sm-1 col-md-2 p-0" for="numero_logradouro"
                    >Número</label
                  >
                  <the-mask
                    id="numero_logradouro"
                    pattern="[0-9\.\-]*"
                    inputmode="numeric"
                    mask="######"
                    :masked="false"
                    v-model="$v.form.numero_logradouro.$model"
                    type="text"
                    required
                    :class="
                      `col-md-2 form-control` +
                      ($v.form.numero_logradouro.$error ? ` is-invalid` : ``)
                    "
                  ></the-mask>
                  <label class="mr-sm-1 col-md-2 p-0" for="bairro"
                    >Bairro</label
                  >
                  <b-form-input
                    id="bairro"
                    v-model="$v.form.bairro.$model"
                    type="text"
                    required
                    class="w-100"
                    :class="
                      `w-100` + ($v.form.bairro.$error ? ` is-invalid` : ``)
                    "
                    disabled
                  ></b-form-input>
                </div>

                <div class="p-0 mb-3 col-12 d-md-flex">
                  <label class="mr-sm-1 col-md-2 p-0" for="tipo_logradouro"
                    >Tipo Logradouro</label
                  >
                  <b-form-input
                    id="tipo_logradouro"
                    v-model="$v.form.tipo_logradouro.$model"
                    type="text"
                    required
                    :class="
                      `col-md-1 mb-2` +
                      ($v.form.tipo_logradouro.$error ? ` is-invalid` : ``)
                    "
                    disabled
                  ></b-form-input>

                  <label class="mr-sm-1 col-md-2 p-0" for="endereco"
                    >Logradouro</label
                  >
                  <b-form-input
                    id="endereco"
                    v-model="$v.form.endereco.$model"
                    type="text"
                    required
                    :class="
                      `col-md-3 mb-2` +
                      ($v.form.endereco.$error ? ` is-invalid` : ``)
                    "
                    disabled
                  ></b-form-input>

                  <label
                    class="mr-sm-1 col-md-2 p-0"
                    for="complemento_logradouro"
                    >Complementos</label
                  >
                  <b-form-input
                    id="complemento_logradouro"
                    v-model="form.complemento_logradouro"
                    type="text"
                    required
                    class="w-100"
                    maxlength="30"
                    @keyup.native="removeAcentos($event)"
                  ></b-form-input>
                </div>
              </b-form>
            </b-card>

            <b-card header="Termo de adesão" header-tag="header">
              <div>
                <p>Declaro que:</p>
                <ul>
                  <li>
                    Faço parte do público beneficiário do Programa Estamos
                    Juntos, sendo ele pessoas em situação ou com trajetória de
                    vida nas ruas, no município de Belo Horizonte;
                  </li>
                  <li>
                    Estou ciente que deixarei de receber o auxílio caso desista
                    do Programa ou não cumpra com os critérios de concessão,
                    sendo eles: frequência mínima de até 60% (sessenta por
                    cento) da carga horária mensal estipulada de ações de
                    inclusão produtiva e não estar inserido no mercado formal de
                    trabalho;
                  </li>
                  <li>
                    Autorizo a criação de conta poupança social digital em meu
                    nome com a instituição contratada para pagamento auxílio,
                    caso não tenha esse tipo de conta;
                  </li>
                  <li>
                    Autorizo a utilização dos dados para fins do Programa
                    Estamos Juntos, observada a Lei Geral de Proteção de Dados
                    Pessoais;
                    <a
                      href="http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm"
                      target="_blank"
                      ><font-awesome-icon
                        class="mr-2"
                        :icon="['fas', 'question-circle']"
                    /></a>
                  </li>
                  <li>
                    Tenho ciência dos termos e condições do Programa Juntos
                    previstos na Lei nº 11.149/2019, no Decreto nº 17.136/2019 e
                    no Decreto nº 18.282/2023.
                    <a
                      href="https://prefeitura.pbh.gov.br/desenvolvimento/estamos-juntos-inclusao-produtiva-de-pessoas-em-situacao-de-rua"
                      target="_blank"
                      ><font-awesome-icon
                        class="mr-2"
                        :icon="['fas', 'question-circle']"
                    /></a>
                  </li>
                </ul>

                <div class="text-center mt-3">
                  <b-button variant="success" @click="termoAdesao = true"
                    >CONCORDO</b-button
                  >
                </div>

                <div
                  class="error text-center mt-3"
                  v-if="$v.termoAdesao.$error"
                >
                  <div v-if="!$v.termoAdesao.required">
                    <small
                      >É necessário clicar em "Concordo" para aceitar o Termo de
                      adesão do Programa e concluir a solicitação de
                      pagamento.</small
                    >
                  </div>
                </div>
              </div>
            </b-card>

            <b-card header="Benefícios contemplados" header-tag="header">
              <b-form-group label="" class="mb-0">
                <b-form-checkbox
                  v-for="beneficio in beneficios"
                  v-model="selected"
                  :key="beneficio.id"
                  :value="beneficio.id"
                  name="beneficios"
                  :disabled="Boolean(beneficio.aceite)"
                >
                  {{ beneficio.nome_beneficio }}

                  <font-awesome-icon
                    :id="`b-${beneficio.id}`"
                    class="mr-2"
                    :icon="['fas', 'question-circle']"
                  />

                  <b-tooltip :target="`b-${beneficio.id}`" triggers="hover">
                    {{ beneficio.termo_beneficio }}
                  </b-tooltip>
                </b-form-checkbox>
              </b-form-group>

              <div class="error" v-if="$v.selected.$error">
                <div v-if="!$v.selected.required">
                  <small>Selecione o(s) seu(s) benefício(s).</small>
                </div>
              </div>
            </b-card>

            <div class="text-center mt-3">
              <b-button
                variant="success"
                v-if="beneficios.length != 0"
                @click="avancar"
                >AVANÇAR</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!------------- botoes contato   ------------------------->
    <!-- <div
      class="container"
      v-if="erroAPI || erroLoginInconsistente || resposta === 'nao'"
    >
      <div class="row mb-3">
        <botoes-contato class="col text-center"></botoes-contato>
      </div>
    </div> -->
    <b-modal v-model="modalShow" ok-only centered>
      <p>{{ msgModal }}</p>
    </b-modal>
    <b-modal
      v-model="modalShowAlteracao"
      title="Informação"
      ok-only
      centered
      header-bg-variant="info"
      header-text-variant="light"
    >
      <p>
        Senhor(a) beneficiário(a), informamos que realizaremos o pagamento do(s)
        auxílio(s) solicitado(s) no próximo mês, pois foi necessário a
        atualização do seu cadastro no Programa Auxílio Belo Horizonte com os
        dados oficiais da Receita Federal.
      </p>
      <p>
        Não é necessário nenhum procedimento adicional. Sua solicitação foi
        realizada com sucesso e a atualização dos dados já foi processada para
        que o pagamento seja realizado já no próximo mês.
      </p>
      <p>
        Pedimos que acompanhe o cronograma de pagamento e saque a ser divulgado
        no site oficial do Programa Auxílio Belo Horizonte.
      </p>
    </b-modal>

    <b-modal
      scrollable
      size="lg"
      header-bg-variant="warning"
      v-model="modalShowCpIrregular"
      title="ALERTA"
      ok-only
      centered
    >
      <p>
        Senhor(a) beneficiário(a), informamos que foi identificado uma
        irregularidade no seu CPF junto a Receita Federal que impede o pagamento
        do(s) auxílio(s) solicitado(s) do Programa Auxílio Belo Horizonte.
      </p>
      <p>
        Portanto, para que sua família possa receber o(s) auxílio(s)
        solicitado(s), é necessário que o Sr.(a) realize a regularização do seu
        CPF junto a Receita Federal até o dia 31/03/22 ou que realize a
        indicação de outro beneficiário de sua família.
      </p>
      <p>
        Caso sua opção seja por cadastrar outro responsável familiar, este
        deverá pertencer ao seu núcleo familiar, ter CPF regular junto à Receita
        Federal e não estar contemplado no Programa Auxílio Belo Horizonte.
        Recomendamos que a regularidade do CPF a ser cadastrado seja verificada
        no site da Receita Federal disponível no link:
        <b-link
          href="https://servicos.receita.fazenda.gov.br/servicos/cpf/consultasituacao/consultapublica.asp"
          >https://servicos.receita.fazenda.gov.br/servicos/cpf/consultasituacao/consultapublica.asp</b-link
        >
      </p>
      <p>
        O cadastramento de outro responsável familiar já está disponível desde o
        dia 20/01/22, com todas as orientações necessárias para sua realização,
        caso essa seja a sua opção.
      </p>
      <p></p>
      A regularização do seu CPF ou indicação de outro responsável familiar com
      CPF regular é indispensável para o pagamento do(s) auxílio(s)
      solicitado(s).
    </b-modal>
  </div>
</template>

<script>
import {
  required,
  requiredIf,
  //minLength,
  //numeric,
  // helpers
} from "vuelidate/lib/validators";

import { TheMask } from "vue-the-mask";
import { paises, cnvTipoLogradouro } from "../helpers";

export default {
  components: {
    TheMask,
    "msg-dados-invalidos": require("./mensagens/_MSGDadosInvalidos").default,
    "msg-login-inconsistente": require("./mensagens/_MSGLoginInconsistente")
      .default,
    //"botoes-contato": require("./layout/BotoesContato").default,
  },
  data() {
    return {
      resultado: {},
      resposta: null,
      dadosCidadao: null,
      dadosSupermercado: null,
      mesReferencia: "",
      anoReferencia: "",
      erroRecuperaDadosSupermercado: null,
      erroRecuperaDadosCidadao: null,
      erroAPI: false,
      erroLoginInconsistente: false,
      temBeneficioExtra: false,
      selected: [],
      estados: [
        "AC",
        "AL",
        "AP",
        "AM",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MT",
        "MS",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RS",
        "RO",
        "RR",
        "SC",
        "SP",
        "SE",
        "TO",
      ],
      tipos: [
        { text: "Selecione", value: null },
        { text: "RG - Registro Geral", value: 1 },
        { text: "CNH - Carteira Nacional de Habilitação", value: 2 },
        { text: "Passaporte", value: 3 },
        { text: "CTPS - Carteira de Trabalho e Previdência Social", value: 4 },
        { text: "CIE - Carteira de Identidade de Estrangeiros", value: 5 },
        { text: "RNE - Registro Nacional de Estrangeiros", value: 6 },
      ],
      termoAdesao: null,
      paises: paises,
      form: {
        data_nascimento: "",
        nome_mae: "",
        nome_completo: "",
        tipo_documento: null,
        numero_documento: "",
        orgao_emissor: "",
        uf_orgao_emissor: null,
        data_emissao: "",
        data_validade: "",
        pais_emissao: "",
        serie_documento: "",
        cep_endereco: "",
        numero_logradouro: "",
        tipo_logradouro: "",
        endereco: "",
        bairro: "",
        complemento_logradouro: "",
        logradouro: "",
        municipio: "BELO HORIZONTE",
        sexo: null,
        alteracao_receita: "",
        situacao_cpf: "",
        selected: [],
      },
      modalShow: false,
      msgModal: "",
      achouCep: true,
      dados: {
        tipo_documento: null,
        uf_orgao_emissor: null,
      },
      tipoSexo: [
        { text: "Masculino", value: "M" },
        { text: "Feminino", value: "F" },
        { text: "Outros", value: "O" },
      ],
      modalShowAlteracao: false,
      modalShowCpIrregular: false,
      habilitaAlteraRF: false,
    };
  },
  validations: {
    selected: {
      required,
    },
    termoAdesao: {
      required,
    },
    form: {
      data_nascimento: {
        required,
        idadeMinima: function (value) {
          var dtNascimento = new Date(value);
          dtNascimento.setFullYear(dtNascimento.getFullYear() + 16);

          return dtNascimento < new Date();
        },
      },
      nome_mae: {
        required,
      },
      sexo: {
        required,
      },
      tipo_documento: {
        required,
      },
      numero_documento: {
        required,
      },
      orgao_emissor: {
        required,
      },
      uf_orgao_emissor: {
        required,
      },
      data_emissao: {
        required,
        menorQueHoje: function (value) {
          var data = new Date(value);
          return data < new Date();
        },
      },
      data_validade: {
        required: requiredIf(function () {
          return this.form.tipo_documento == 3;
        }),
      },
      pais_emissao: {
        required: requiredIf(function () {
          return this.form.tipo_documento == 3;
        }),
      },
      serie_documento: {
        required: requiredIf(function () {
          return this.form.tipo_documento == 4;
        }),
      },
      cep_endereco: {
        required,
      },
      numero_logradouro: {
        required,
      },
      tipo_logradouro: {
        required,
      },
      bairro: {
        required,
      },
      endereco: {
        required,
      },
    },
  },
  computed: {
    http() {
      return this.$store.getters.http;
    },
    cpf() {
      return this.$store.getters.cpf;
    },
    nome() {
      return this.$store.getters.nome;
    },
    beneficios() {
      return this.$store.getters.beneficios;
    },
    familia() {
      return this.$store.getters.familia;
    },
    dadosForm() {
      return this.$store.getters.dadosForm;
    },
  },
  methods: {
    alterarResp() {
      this.$router.push({
        name: "beneficiarioFormAlterarResponsavel",
        params: { dados: this.familia, origem: "cidadao" },
      });
    },
    changeOrgao() {
      if (/^[a-zA-Z\s]*$/.test(this.form.orgao_emissor)) {
        return true; // Match with regex
      } else this.form.orgao_emissor = "";
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z\s]*$/.test(char)) {
        return true; // Match with regex
      } else e.preventDefault(); // If not match, don't add to input text
    },
    changeTipoDocumento() {
      setTimeout(() => {
        if (this.form.tipo_documento != 3) {
          this.form.data_validade = "";
          this.form.pais_emissao = null;
        }

        if (this.form.tipo_documento != 4) {
          this.form.serie_documento = "";
        }
      }, 1);
    },
    removeAcentos(e) {
      var texto = e.target.value;
      var semAcento = texto
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase();
      e.target.value = semAcento;
    },
    buscaCep() {
      if (this.form.cep_endereco.length == 8) {
        let cep = this.form.cep_endereco;
        var uri = `https://geocoder.pbh.gov.br/geocoder/v2/address?cep=${cep}`;
        // if( this.form.numero_logradouro ) {
        //   let numero = this.form.numero_logradouro;
        //   uri += `&numero=${numero}`;
        // }

        fetch(uri)
          .then((resp) => resp.json())
          .then((data) => {
            const endereco = data.endereco[0];
            this.form.tipo_logradouro = endereco.tipologradouro
              ? cnvTipoLogradouro(endereco.tipologradouro)
              : null;
            this.form.endereco = endereco.nomelogradouro;
            this.form.bairro = endereco.bairropopular;
            if (endereco.id == "") {
              this.achouCep = false;
              this.modalShow = true;
              this.msgModal =
                "CEP inválido ou não encontrado. Digite um CEP de BELO HORIZONTE.";
            } else {
              this.achouCep = true;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    // buscaCepNumero() {
    //   if( this.form.cep_endereco.length == 8) {
    //     let cep = this.form.cep_endereco;
    //     var uri = `https://geocoder.pbh.gov.br/geocoder/v2/address?cep=${cep}`;
    //     if( this.form.numero_logradouro ) {
    //       let numero = this.form.numero_logradouro;
    //       uri += `&numero=${numero}`;
    //     }

    //     fetch(uri)
    //     .then((resp) => resp.json())
    //     .then((data) => {
    //       const endereco = data.endereco[0];
    //       this.form.tipo_logradouro = endereco.tipologradouro ? cnvTipoLogradouro(endereco.tipologradouro) : null;
    //       this.form.endereco = endereco.nomelogradouro;
    //       this.form.bairro   = endereco.bairropopular;
    //       if( endereco.id == "" && this.achouCep ) {
    //         this.modalShow = true;
    //         this.msgModal = 'Número inválido ou não encontrado. Digite o número correto de sua residência.';
    //       }
    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //     });
    //   }
    // },
    load() {
      if (this.familia.alteracao_receita === "S") {
        this.modalShowAlteracao = true;
      } else if (this.familia.situacao_cpf != 0) {
        if (this.familia.situacao_cpf == null) {
          this.modalShowCpIrregular = false;
          this.habilitaAlteraRF = false;
        } else {
          this.modalShowCpIrregular = true;
          this.habilitaAlteraRF = true;
        }
      }
      const dados = this.dadosForm.dados ? this.dadosForm.dados : this.dados;
      this.form.data_nascimento = this.familia.data_nascimento
        ? this.familia.data_nascimento
        : dados.data_nascimento;
      this.form.cpf_requerente = this.familia.cpf_requerente
        ? this.familia.cpf_requerente
        : dados.cpf_requerente;
      this.form.nome_completo = this.familia.nome_completo
        ? this.familia.nome_completo
        : dados.nome_completo;
      this.form.nome_mae = this.familia.nome_mae
        ? this.familia.nome_mae
        : dados.nome_mae;
      this.form.tipo_documento = this.familia.tipo_documento
        ? this.familia.tipo_documento
        : dados.tipo_documento;
      this.form.numero_documento = this.familia.numero_documento
        ? this.familia.numero_documento
        : dados.numero_documento;
      this.form.orgao_emissor = this.familia.orgao_emissor
        ? this.familia.orgao_emissor
        : dados.orgao_emissor;
      this.form.uf_orgao_emissor = this.familia.uf_orgao_emissor
        ? this.familia.uf_orgao_emissor
        : dados.uf_orgao_emissor;
      this.form.data_emissao = this.familia.data_emissao
        ? this.familia.data_emissao
        : dados.data_emissao;
      this.form.data_validade =
        this.familia.data_validade !== {}
          ? this.familia.data_validade
          : dados.data_validade
          ? dados.data_validade
          : null;
      this.form.pais_emissao =
        this.familia.pais_emissao !== {}
          ? this.familia.pais_emissao
          : dados.pais_emissao;
      this.form.serie_documento =
        this.familia.serie_documento !== {}
          ? this.familia.serie_documento
          : dados.serie_documento;
      this.form.cep_endereco = this.familia.cep_endereco
        ? this.familia.cep_endereco
        : dados.cep_endereco;
      this.form.numero_logradouro = this.familia.numero_logradouro
        ? this.familia.numero_logradouro
        : dados.numero_logradouro;
      this.form.tipo_logradouro = this.familia.tipo_logradouro
        ? this.familia.tipo_logradouro
        : dados.tipo_logradouro;
      this.form.endereco = this.familia.endereco
        ? this.familia.endereco
        : dados.endereco;
      this.form.complemento_logradouro = this.familia.complemento_logradouro
        ? this.familia.complemento_logradouro
        : dados.complemento_logradouro;
      this.form.bairro = this.familia.bairro
        ? this.familia.bairro
        : dados.bairro;
      this.form.sexo = this.familia.sexo ? this.familia.sexo : dados.sexo;
      this.form.alteracao_receita = this.familia.alteracao_receita
        ? this.familia.alteracao_receita
        : dados.alteracao_receita;
      this.form.situacao_cpf = this.familia.situacao_cpf
        ? this.familia.situacao_cpf
        : dados.situacao_cpf;
      this.buscaCep();
    },
    resetErros() {
      this.erroRecuperaDadosCidadao = null;
      this.erroRecuperaDadosSupermercado = null;
      this.erroAPI = false;
    },
    avancar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.form.selected = this.selected;

        let bodyFamilia = {
          id_familia: this.familia.id,
          dados: this.form,
        };

        this.$store.commit("setDadosForm", bodyFamilia);

        if (this.selected.length != this.beneficios.length) {
          this.$bvModal
            .msgBoxConfirm(
              "Você não selecionou todos os benefícios que tem direito, tem certeza que só irá aceitar o(s) benefício(s) selecionado(s)?",
              {
                title: "Confirmação",
                centered: true,
                okTitle: "Estou de acordo",
                cancelTitle: "Quero selecionar mais",
                showCancelButton: false,
              }
            )
            .then((value) => {
              if (value) {
                //this.$store.commit("setDadosForm", bodyFamilia);
                this.$router.push("confirmacao");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          //this.$store.commit("setDadosForm", bodyFamilia);
          this.$router.push("confirmacao");
        }
      }
    },
  },
  async mounted() {
    this.$store.commit("registraRetornoComDados", false);

    this.beneficios.map((beneficio) => {
      //if(beneficio.aceite) {
      this.selected.push(beneficio.id);
      //}
    });

    this.load();
  },
};
</script>

<style scoped>
.error {
  color: #dc3545;
}
#turno {
  text-transform: uppercase;
}
</style>
